<template>
  <div class="row">
    <div class="col-12">
    <card class="loading-card" :title="title" :subTitle="subTitle">
      <div class="text-center text-muted">
        <div class="spinner-border large-spinner" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </card>
    </div>
  </div>    
</template>

<script>
import Card from './Card.vue';

export default {
  components: {
    Card
  },
  props: {
    title: String,
    subTitle: String
  }
}
</script>

<style lang="scss" scoped>
.loading-card {
  height: 300px;
}

.large-spinner {
  width: 3rem;
  height: 3rem;
  margin-top: 60px;
}
</style>